import React from 'react';
import {CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";

const Graph = ({ data, codes }) => {
    const lines = codes.map(code => {
        const color = '#'+Math.floor(Math.random()*16777215).toString(16).padStart(6, '0');

        return <Line yAxisId="left" type="linear" dataKey={code} stroke={color} dot={{ stroke: color, strokeWidth: 3 }} activeDot={{ stroke: color, strokeWidth: 3 }} strokeWidth={3}/>
    });

    return (
        <ResponsiveContainer width={'100%'} height={300}>
            <LineChart
                width={500}
                height={300}
                data={data}
                margin={{
                    top: 5, right: 30, left: 20, bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis yAxisId="left" />
                <Tooltip/>
                <Legend/>
                {lines}
            </LineChart>
        </ResponsiveContainer>
    );
}

export default Graph;


// WEBPACK FOOTER //
// ./src/scenes/BidderError/components/Graph/index.js